<template>
    <HeaderBar></HeaderBar>
    <div class="h_main" id="h_main">
        <a id="maodian"></a>
        <div class="h_menu" id="h_menu">
            <div :class="item.class_name" v-for="item in types" v-bind:key="item.id" v-on:click="clickType(item.id)">{{ item.name }}</div>
        </div>
        <div class="h_group">
            <div v-for="outItem in datas" v-bind:key="outItem.id" class="h_group_item">
                <div class="sideTitle">
                    <a :href="outItem.href" target="_blank"><img :src="outItem.icon"/>{{outItem.name}}</a>
                    <span class="hot_type">{{ outItem.hot_type }}</span>
                </div>
                <div class="sideHotItems">
                    <div v-for="(item,index) in outItem.items" v-bind:key="item.id" class="hot_item">
                        <div :class="index>2?'num_fourth':'num_third'">{{ index+1 }}</div>
                        <a :href="item.url" target="_blank" v-on:click="clickLink(item.id,2)">
                            {{ item.title }}
                        </a>
                        <div class="hot_number" v-if="item.number>=100000">{{parseInt(item.number/10000)}}万</div>
                        <div class="hot_number" v-else-if="item.number<=0 && item.number_text == null" style="width: 0px;"></div>
                        <div class="hot_number" v-else-if="item.number<=0 && item.number_text != ''">{{ item.number_text }}</div>
                        <div class="hot_number" v-else>{{item.number}}</div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <FooterBar></FooterBar>
</template>
<script>
/* eslint-disable no-unused-vars */
import http from '../http.js';
import HeaderBar from '@/components/HeaderBar.vue';
import FooterBar from '@/components/FooterBar.vue';
    export default {
        name: 'HotRank',
        components:{
            HeaderBar,
            FooterBar
        },
        data(){
            return{
                leftPx:0,
                datas:[],
                types:[],
                type_item_class:"h_menu_item"
            }
        },
        mounted(){
            this.getHotType();
            this.getHotDatas(1);
            this.setMenuBarLeft();
            window.addEventListener('resize', this.setMenuBarLeft);
        },
        methods:{
            clickType(id){
                var select_id = 0;
                this.types.forEach((item)=>{
                    if(item.class_name=="h_menu_item_select"){
                        select_id = item.id;
                    }
                    item.class_name="h_menu_item";
                    if(item.id==id){
                        item.class_name="h_menu_item_select";
                    }
                });
                if(id != select_id){
                    this.getHotDatas(id);
                    const section = document.getElementById("maodian");
                    if (section) {
                        window.scrollTo({
                            top: section.offsetTop-70,
                            behavior: 'smooth'
                        });
                    }
                }
            },
            setMenuBarLeft(){
                let h_main = document.getElementById('h_main'); 
                if(h_main != undefined && h_main != null)
                    this.leftPx = h_main.offsetLeft;
                var h_menu=document.getElementById('h_menu');
                if(h_menu != undefined && h_menu != null)
                    h_menu.style.left = this.leftPx + 'px';
            },
            getHotType(){
                http.get('/getHotType')
                .then(response => {
                    this.types=response;
                    var index = 0;
                    this.types.forEach((item)=>{
                        item.class_name="h_menu_item";
                        if(index==0){
                            item.class_name="h_menu_item_select";
                        }
                        index++;
                    });
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            getHotDatas(type){
                http.post('/getTypeHots',{"type_id":type})
                .then(response => {
                    this.datas=response
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            clickLink(id,type){
                http.post('/linkClick',{"id":id,"type":type})
                .then(response => {
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            }
        }
    }
</script>

<style scoped>
@import '../assets/styles.css';
    .h_main{
        width: 1280px;
        margin: 0 auto;
        margin-top: 70px;
        text-align: left;
        min-height: calc(100vh - 127px);
    }
    .h_menu{
        position: fixed;
        left:0;
        top:70px;
        bottom: 0;
        z-index: 998;
        background-color: rgb(240, 241, 241);
        width: 76px;
        border-radius:5px;
        padding: 5px;
        height: auto; /* 高度根据内容自适应 */
        box-sizing: border-box; /* 防止宽度计算错误 */
    }
    .h_menu_item,.h_menu_item_select{
        border:1px solid rgb(240, 241, 241);
        border-radius:5px;
        text-align: center;
        padding: 10px 0px;
        color: gray;
        margin: 5px 0px;
        cursor: pointer;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none;    /* Firefox */
        -ms-user-select: none;     /* IE/Edge */
        user-select: none;         /* 标准语法 */
        display: flex;
        align-items: center; /* 垂直居中 */
        justify-content: center; /* 水平居中，如果也需要水平居中的话 */
    }
    .h_menu_item:hover,.h_menu_item_select{
        border:1px solid #2486b9;
        border-radius:5px;
        color:white;
        background-color: #2486b9;
    }
    .h_group{
        display: flex;
        flex-flow:row wrap;
        margin-left: 76px;
        margin-bottom: 20px;
        padding: 5px 0px 0px 20px;
    }
    .sideTitle img{
        width: 18px;
        height: 18px;
        vertical-align: top;
        margin-right: 5px;
        margin-top: 2px;
    }
    .hot_type{
        font-size: 15px;
        color: gray;
        float: right;
    }
    .sideHotItems{
        max-height: 310px;
    }
    .h_group_item{
        border:1px solid #DEE3EB;
        border-radius:5px;
        margin-right: 20px;
        margin-bottom: 20px;
        width: 370px;
    }
    .hot_item a{
        min-width: 270px;
        font-size: 14px;
    }
    .hot_number{
        margin-right: 2px;
        text-align: right;
        width: 100%;
    }
</style>